export const BREAKPOINTS = {
  MOBILE_DOWN: 480,
  MOBILE_UP: 481,
};
